<template>
  <div>
    <article
      class="p-4 bg-white border -ms-px -mt-px md:rounded-md dark:bg-gray-900 dark:border-gray-700"
    >
      <div class="animate-pulse">
        <div class="h-24 bg-shimmer rounded-md dark:bg-gray-850"></div>
        <div class="mt-4 flex-grow">
          <div class="h-5 bg-shimmer rounded dark:bg-gray-850"></div>
          <div class="h-3 bg-shimmer rounded dark:bg-gray-850 mt-2"></div>
        </div>
      </div>
    </article>
  </div>
</template>
